<template>
  <el-select
    ref="selectTree"
    v-model="value"
    :placeholder="placeholder"
    clearable
    @clear="clearValue"
    @remove-tag="removeTag"
    :disabled="disabled"
    :multiple="multiple"
    :collapse-tags="collapsTags"
  >
    <el-option :value="values" hidden />
    <el-tree
      ref="treeOption"
      highlight-current
      accordion
      :node-key="defaultProps.value"
      :default-expanded-keys="defaultExpandedKeys"
      :data="options"
      :props="pageDefaultProps"
      @check="checkNode"
      @node-click="checkNode"
      :show-checkbox="multiple"
    />
  </el-select>
</template>

<script>
export default {
  name: 'CompleteTreeSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: () => {
        return '请选择'
      }
    },
    collapsTags: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    // 影响绑定的数据
    EObjArr: {
      type: Array,
      default: () => []
    },
    // 节点数据
    options: {
      type: Array, // 必须是树形结构的对象数组
      default: () => {
        return []
      }
    },
    // 设置lable value属性
    defaultProps: {
      type: Object,
      default: () => {
        return {
          parentValue: 'parentValue', // 上级字段value值，用于给多选时默认展开defaultExpandedKeys
          value: 'value', // ID字段名
          label: 'label', // 显示名称
          children: 'children' // 子级字段名
        }
      }
    },
    // 默认勾选的节点
    defaultCheckNodes: {
      type: Array, // 已经分配的资源
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      value: '',
      values: [],
      currentNodeKey: '',
      defaultcheckedKeys: [],
      defaultExpandedKeys: []
    }
  },
  watch: {
    EObjArr (val) {
      if (this.multiple) {
        this.value = []
        val.forEach(item => {
          this.value.push(item[this.defaultProps.label])
          this.values.push(item)
          this.defaultcheckedKeys.push(item[this.defaultProps.value])
          this.defaultExpandedKeys.push(item[this.defaultProps.parentValue])
          this.$nextTick(() => {
            this.$refs.treeOption.setChecked(
              item[this.defaultProps.value],
              true,
              false
            )
          })
        })
      } else {
        this.value = val[0][this.defaultProps.label]
        this.values = val[0]
        this.defaultExpandedKeys.push(
          this.EObjArr[0][this.defaultProps.parentValue]
        )
        this.$nextTick(() => {
          // this.currentNodeKey = this.EObjArr[0][this.defaultProps.value]
          this.$refs.treeOption.setCurrentNode(this.EObjArr[0])
          // this.$refs.treeOption.setCurrentKey(this.currentNodeKey)
        })
      }
    }
  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.defaultExpandedKeys = []
        if (this.EObjArr && this.EObjArr.length) {
          if (this.multiple) {
            // 多选功能
            this.EObjArr.forEach(item => {
              this.value.push(item[this.defaultProps.label])
              this.values.push(item)
              this.defaultcheckedKeys.push(item[this.defaultProps.value])
              this.defaultExpandedKeys.push(
                item[this.defaultProps.parentValue]
              )
              this.$nextTick(() => {
                this.$refs.treeOption.setChecked(
                  item[this.defaultProps.value],
                  true,
                  false
                )
                // this.$refs.treeOption.setCheckedNodes(this.values)
                // this.$refs.treeOption.setCheckedKeys(this.defaultcheckedKeys)
              })
            })
          } else {
            // 单选功能
            this.value = this.EObjArr[0][this.defaultProps.label]
            this.values = this.EObjArr[0]
            this.defaultExpandedKeys.push(
              this.EObjArr[0][this.defaultProps.parentValue]
            )
            this.$nextTick(() => {
              // this.currentNodeKey = this.EObjArr[0][this.defaultProps.value]
              this.$refs.treeOption.setCurrentNode(this.EObjArr[0])
              // this.$refs.treeOption.setCurrentKey(this.currentNodeKey)
            })
          }
        } else {
          this.defaultExpandedKeys.push(
            this.options[0][this.defaultProps.value]
          )
          this.value = ''
        }
      })
    },
    clearValue () {
      this.value = ''
      this.$refs.treeOption.setCurrentKey(null)
      this.$emit('input', [])
    },
    // 删除tag时，
    removeTag (val) {
      // 取消勾选
      for (var i = 0; i < this.values.length; i++) {
        if (this.values[i][this.defaultProps.label] == val) {
          this.$refs.treeOption.setChecked(
            this.values[i][this.defaultProps.value],
            false,
            false
          )
          this.values.splice(i, 1)
          // 重新给控件赋值
          this.$emit('input', this.values, this.value)
        }
      }
    },
    // 勾选节点，
    checkNode (node, checkedNodes) {
      // console.log('node', node)
      if (this.multiple) {
        // 可勾选
        if (checkedNodes && checkedNodes.checkedNodes) {
          this.value = []
          this.values = []
          checkedNodes.checkedNodes.forEach(item => {
            if (item.children == null) {
              this.value.push(item[this.defaultProps.label])
              this.values.push(item)
            }
          })
          this.$emit('input', this.values, this.value)
        }
      } else {
        // 单选
        if (node.children == null) {
          this.value = node[this.defaultProps.label]
          this.values = node
          this.$refs.selectTree.blur()
          this.$emit('input', node, this.value)
        }
      }
    }
  }
}
</script>

<style scoped>
/* 去除tree上面的一行高度 */
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  padding: 0;
}
</style>
